  if (!customElements.get('nps-footer-box')) {
    customElements.define('nps-footer-box', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.image = this.querySelector('img');
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.visible = false;
        this.loopReady = false;
        this.loopLoader = null;
        this.loopFailed = false;
        this.sync = () => {
          const requested = this.visible && !this.motion.matches && !document.hidden;
          if (requested && !this.loopLoader && !this.loopFailed) {
            this.loopLoader = new Image();
            this.loopLoader.onload = () => {
              this.loopReady = true;
              this.sync();
            };
            this.loopLoader.onerror = () => {
              this.loopFailed = true;
              this.sync();
            };
            this.loopLoader.src = this.dataset.loopSrc;
          }
          const source = requested && this.loopReady ? this.dataset.loopSrc : this.dataset.posterSrc;
          if (this.image.getAttribute('src') !== source) this.image.src = source;
        };
        this.motion.addEventListener('change', this.sync);
        document.addEventListener('visibilitychange', this.sync);
        this.observer = new IntersectionObserver((entries) => {
          this.visible = entries[0].isIntersecting;
          this.sync();
        }, { rootMargin: '100px 0px' });
        this.observer.observe(this);
        this.sync();
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        if (this.loopLoader) {
          this.loopLoader.onload = null;
          this.loopLoader.onerror = null;
        }
        this.motion?.removeEventListener('change', this.sync);
        document.removeEventListener('visibilitychange', this.sync);
        this.initialized = false;
      }
    });
  }

